import './style.scss';

import { ChangePasswordModal } from '../changePassword/modal';
import { AgreementDocumentModal } from '../agreementDocument/modal';

import { Outlet, ScrollRestoration } from 'react-router-dom';
import { CenterNav } from 'views/components/organisms/centerNav';
import { SideMenuPc, SideMenuSP } from 'views/components/organisms/leftNav';
import { GlobalLoading } from 'views/components/organisms/globalLoading';
import { GlobalToast } from 'views/components/organisms/globalToast';

import { useLayout, ForceInputStep} from './hooks'


export const Layout = () => {
  const { step, changePasswordComplete } = useLayout();

  if(step === ForceInputStep.ChangePassword){
    return <ChangePasswordModal isModal={true} onCompleted={changePasswordComplete} />
  }

  return (
    <div className="body">
      <ScrollRestoration />
      <SideMenuPc />
      <SideMenuSP />
      <div className="mainContent">
        <CenterNav />
        <Outlet />
        {step === ForceInputStep.NotLogin &&(
          <></>
        )}
        {step === ForceInputStep.AgreementDocument &&(
          <AgreementDocumentModal />
        )}
      </div>
      <GlobalLoading />
      <GlobalToast />
    </div>
  );
};
